<template>
  <div class="Dashboard">
    <TopicTitle />
    <div class="sortingPanel">
      <div class="leftSide">
        <div class="difficultyLabels">
          <DifficultyLabel :difficulty="1" :sortLabel="true" />
          <DifficultyLabel :difficulty="2" :sortLabel="true" />
          <DifficultyLabel :difficulty="3" :sortLabel="true" />
        </div>
        <div class="typeSwitch">
          <TypeSwitch />
        </div>
      </div>

      <Searchbar />
    </div>
    <Progressbar />
  </div>
</template>

<script>
import TopicTitle from "./TopicTitle";
import DifficultyLabel from "./DifficultyLabel";
import TypeSwitch from "./TypeSwitch";
import Searchbar from "./Searchbar";
import Progressbar from "./Progressbar";

export default {
  name: "Dashboard",
  components: {
    TopicTitle,
    DifficultyLabel,
    TypeSwitch,
    Searchbar,
    Progressbar,
  },
};
</script>

<style lang="scss" scoped>
.Dashboard {
  margin-bottom: 30px;
}

.sortingPanel {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .leftSide {
    display: flex;
    align-items: center;
  }
  .difficultyLabels {
    margin-right: 30px;
  }
  .typeSwitch {
    display: flex;
    align-items: center;
  }
}

@media screen and (max-width: 1200px) {
  .sortingPanel {
    display: none;
  }
}
</style>
